<template>
  <v-container fluid>
    <v-btn
      :to="{ name: 'admin.index' }"
      elevation="0"
      tile
      icon
    >
      <v-icon size="20">mdi-arrow-left</v-icon>
    </v-btn>
    <v-divider class="mb-3 mt-1"></v-divider>
    <v-row justify="center">
      <v-col cols="4">
        <v-form>
          <h3 class="mb-0">Remove multiple users</h3>
          <p class="caption mb-5">
            Once you click remove button all the users can't be recovered,
            take your precautions
          </p>
          <v-textarea v-model="emails" height="300" outlined no-resize></v-textarea>
          <div class="text-right">
            <v-btn
              type="submit"
              color="error"
              :disabled="disabled"
              @click.prevent="remove"
            >Remove</v-btn>
          </div>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { User } from '@/api';

export default {
  name: 'app-bulk-delete',
  data() {
    return {
      disabled: false,
      emails: '',
    };
  },
  methods: {
    async remove() {
      if (this.emails) {
        const emails = this.emails.split(/\n|\s/g).filter(Boolean);
        this.disabled = true;

        try {
          await User.bulkDelete(emails);
          this.emails = '';
        } finally {
          this.disabled = false;
        }
      }
    },
  },
};
</script>
